import React from 'react';
import {
  Grid,
  makeStyles,
  Checkbox,
  Link,
  IconButton,
} from '@material-ui/core';
// import { useHistory } from 'react-router-dom';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import EditIcon from '@material-ui/icons/Edit';
import DescriptionIcon from '@material-ui/icons/Description';
import moment from 'moment';
import { PRODUCTS, useCommonAuth } from '../../../submodule';
import { useStoreState } from 'easy-peasy';
import '../listItem.component.scss';

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.primary.main,
  },
  rounded: {
    backgroundColor: theme.palette.grey[50],
    border: `1px solid #9D9D9D`,
    color: '#9D9D9D',
    width: '30px',
    height: '30px',
    cursor: 'pointer',
  },
  listItem: {
    color: '#434343',
    border: '1px solid #ededed',
    alignItems: 'center',
  },
}));

const UserListItem = ({
  entityData,
  index,
  listData,
  setListData,
  handleInlineStatusChange,
  setChangeIndex,
  setShowModal,
  pageNumber,
  paginationLimit,
}) => {
  const classes = useStyles();
  // const history = useHistory();
  const {userModulePermissions} = useCommonAuth();
  const loggedInUserInfo = useStoreState((state) => state.login.userInfo);

  function handleChange(event) {
    const data = [...listData];

    data.map((item, index) => {
      if (item.PK + '_' + item.SK === event.target.value) {
        data[index].checked = event.target.checked;
      }
      return item;
    });
    setListData(data);
  }

  function handleStatus(event) {
    let item = { ...entityData };
    if (event.target.checked === true) {
      item.current_status = 'ACTIVE';
    } else {
      item.current_status = 'INACTIVE';
    }

    handleInlineStatusChange(item);
  }
  return (
    <Grid container className={classes.listItem}>
      <Grid item xs={'auto'} style={{ padding: '0 20px' }}>
        <Grid container spacing={1} style={{ padding: '10px 0 20px 0'}}>
          <Grid item xs={12}>
            <Checkbox
              name="checkedD"
              color="primary"
              data-testid="checkedD"
              value={`${entityData.PK}_${entityData.SK}`}
              checked={
                entityData.checked && entityData.checked === true ? true : false
              }
              disabled={loggedInUserInfo.PK === entityData.PK}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            &nbsp;
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={11}>
        <Grid container spacing={1} style={{ padding: '20px 0' }}>
          <Grid item xs={12} className="textItemTitle">
            <Link
              style={{ textDecoration: 'none' }}
              // onClick={() => {
              //   history.push(
              //     `users/${encodeURIComponent(entityData.PK)}`,
              //   );
              // }}
            >
              {entityData.username}
            </Link>
            <br />
          </Grid>

          <Grid
            item
            xs={4}
            className="secondaryText"
          >
            <Grid
              container
              style={{ display: 'flex', flexDirection: 'column' }}
            >
              <Grid item>First Name: {entityData.firstname}</Grid>
              <Grid item>Last Name: {entityData.lastname}</Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={4}
          >
            <Grid
              container
              style={{ display: 'flex', flexDirection: 'column' }}
            >
              <Grid item>Phone: {entityData.phone || 'N/A'}</Grid>
              <Grid item>Email: {entityData.email || 'N/A'}</Grid>
              <Grid item>Last Login: {entityData.last_login? moment(entityData.last_login).format('MM-DD-YYYY hh:mm:ss') : 'N/A'}</Grid>
            </Grid>
          </Grid>

          <Grid item xs={3}>
            <FormControl component="fieldset">
              <FormGroup>
                <FormControlLabel
                  data-testid="current_status_lable"
                  control={
                    <Switch
                      color="primary"
                      name="current_status"
                      data-testid="current_status"
                      checked={
                        entityData.current_status == 'ACTIVE' ? true : false
                      }
                      onChange={(event) => userModulePermissions('users', 'edit', PRODUCTS.MAINAPP) ? handleStatus(event) : ''}
                      disabled={loggedInUserInfo.PK === entityData.PK || entityData.root_user == 1}
                    />
                  }
                  label={
                    entityData.current_status == 'ACTIVE'
                      ? 'ACTIVE'
                      : 'INACTIVE'
                  }
                  className="switchLabel"
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item xs={1}  style={{ display: 'flex'}}>
            { userModulePermissions('users', 'edit', PRODUCTS.MAINAPP) && (typeof entityData?.is_sso_user === 'undefined') ?  (
              <IconButton
                color="primary"
                edge="end"
                aria-label="edit"
                onClick={() => {
                  setChangeIndex(index + ((pageNumber-1)*paginationLimit));
                  setShowModal(true);
                }}
                disabled={loggedInUserInfo.PK === entityData.PK || entityData.root_user == 1}
              >
                <EditIcon />
              </IconButton>
            ) : (<IconButton
                color="primary"
                aria-label="View User"
                onClick={() => {
                  setChangeIndex(index + ((pageNumber-1)*paginationLimit));
                  setShowModal(true);
                }}
              >
                <DescriptionIcon />
              </IconButton>)
          }
          </Grid>
            
        </Grid>
      </Grid>
    </Grid>
  );
};

export default UserListItem;
